import React, { Component } from "react";

import { connect } from "react-redux";

import { sdg1671bActions } from "../../../../../../_actions";
import { TextInput, NumberInput } from "carbon-components-react";

class RatiosTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
      error: props.error,
      editingFields: {}, // Track fields being edited locally
      focusedFields: {} // Track which fields are focused
    };

    this.goToMetadata = this.goToMetadata.bind(this);
    this.updateDenominator = this.updateDenominator.bind(this);
    this.calculateYouthRatio = this.calculateYouthRatio.bind(this);
    this.calculateRatioWithDenominator = this.calculateRatioWithDenominator.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  handleChange(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    
    if (isOGC) {
      // For OGC users, store the value locally while typing
      this.setState({
        editingFields: {
          ...this.state.editingFields,
          [e.target.name]: e.target.value
        }
      });
    } else {
      // For non-OGC users, update Redux directly
      let { dispatch } = this.props;
      dispatch(
        sdg1671bActions.updateRatios(e.target.name, parseFloat(e.target.value) || null)
      );
    }
  }

  handleFocus(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    
    if (isOGC) {
      // Check if this field can be calculated - if so, don't allow editing
      // Only check for female ratio fields (not denominator-based fields)
      const column = this.getColumnForField(e.target.name);
      if (column && this.canCalculateRatio(column)) {
        return; // Field should be disabled, but just in case
      }
      
      // Track that this field is focused
      this.setState({
        focusedFields: {
          ...this.state.focusedFields,
          [e.target.name]: true
        }
      });
      
      // If the stored value is 0 or null, start with empty string for easier editing
      const storedValue = this.props.data && this.props.data.ratios && this.props.data.ratios[0] 
        ? this.props.data.ratios[0][e.target.name] 
        : null;
      
      if (storedValue === null || storedValue === undefined || storedValue === 0) {
        this.setState({
          editingFields: {
            ...this.state.editingFields,
            [e.target.name]: ""
          }
        });
      } else {
        // Initialize with the stored value as a string for editing
        this.setState({
          editingFields: {
            ...this.state.editingFields,
            [e.target.name]: String(storedValue)
          }
        });
      }
    }
  }

  getColumnForField(fieldName) {
    // Map field names to their corresponding column names
    const fieldToColumnMap = {
      "female_senior_managers": "total_officials",
      "female_other_managers": "total_executives",
      "female_administration_professionals": "total_professionals",
      "female_ba_associate_professionals": "total_associate",
      "female_gk_clerks": "total_general",
      "female_total_national": "total_national"
    };
    return fieldToColumnMap[fieldName];
  }

  canCalculateYouthRatio() {
    // Check if youth ratio can be calculated
    if (!this.props.data || !this.props.data.denominator) {
      return false;
    }
    
    const youthRatio = this.props.data.denominator["youth_ratio"];
    if (!youthRatio || youthRatio === 0) {
      return false;
    }
    
    // Check if proportions data exists
    const below25 = this.getProportionsRowTotals("below_25");
    const age25_34 = this.getProportionsRowTotals("age_25_34");
    
    return (below25 !== 0 || age25_34 !== 0);
  }

  canCalculateRatioWithDenominator(proportion, denominatorName) {
    // Check if ratio can be calculated with denominator
    if (!this.props.data || !this.props.data.denominator) {
      return false;
    }
    
    const denominator = this.props.data.denominator[denominatorName];
    if (!denominator || denominator === 0) {
      return false;
    }
    
    // Check if proportions data exists
    const proportionValue = this.getProportionsRowTotals(proportion);
    
    return proportionValue !== 0;
  }

  getYouthRatioValue() {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    const canCalculate = this.canCalculateYouthRatio();
    
    // If value can be calculated, always use calculated value
    if (canCalculate) {
      return this.calculateYouthRatio();
    }
    
    // If user is currently editing this field, return the local value
    if (isOGC && this.state.editingFields && this.state.editingFields["bellow34_total_national"] !== undefined) {
      return this.state.editingFields["bellow34_total_national"];
    }
    
    // If calculation is not possible, return stored value (for both OGC and non-OGC users)
    if (this.props.data && this.props.data.ratios && this.props.data.ratios[0]) {
      const storedValue = this.props.data.ratios[0]["bellow34_total_national"];
      
      if (storedValue === null || storedValue === undefined || storedValue === 0) {
        return "0.00";
      }
      
      return parseFloat(storedValue).toFixed(2);
    }
    
    // If no data exists at all, return "0.00"
    return "0.00";
  }

  getRatioWithDenominatorValue(proportion, denominator, name) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    const canCalculate = this.canCalculateRatioWithDenominator(proportion, denominator);
    
    // If value can be calculated, always use calculated value
    if (canCalculate) {
      return this.calculateRatioWithDenominator(proportion, denominator, name);
    }
    
    // If user is currently editing this field, return the local value
    if (isOGC && this.state.editingFields && this.state.editingFields[name] !== undefined) {
      return this.state.editingFields[name];
    }
    
    // If calculation is not possible, return stored value (for both OGC and non-OGC users)
    if (this.props.data && this.props.data.ratios && this.props.data.ratios[0]) {
      const storedValue = this.props.data.ratios[0][name];
      
      if (storedValue === null || storedValue === undefined || storedValue === 0) {
        return "0.00";
      }
      
      return parseFloat(storedValue).toFixed(2);
    }
    
    // If no data exists at all, return "0.00"
    return "0.00";
  }

  handleBlur(e) {
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    
    if (isOGC) {
      // When user finishes editing, update Redux
      const inputValue = e.target.value.trim();
      let value;
      
      if (inputValue === "" || inputValue === "0" || inputValue === "0.00" || inputValue === "0.0") {
        // If empty or 0, save as null (will display as "0.00" next time)
        value = null;
      } else {
        const parsed = parseFloat(inputValue);
        value = isNaN(parsed) ? null : parsed;
      }
      
      let { dispatch } = this.props;
      dispatch(
        sdg1671bActions.updateRatios(e.target.name, value)
      );
      
      // Clear local editing and focus state
      const newEditingFields = { ...this.state.editingFields };
      const newFocusedFields = { ...this.state.focusedFields };
      delete newEditingFields[e.target.name];
      delete newFocusedFields[e.target.name];
      this.setState({ 
        editingFields: newEditingFields,
        focusedFields: newFocusedFields
      });
    }
  }

  updateDenominator(e) {
    let { dispatch } = this.props;

    dispatch(
      sdg1671bActions.updateDenominator(e.target.name, parseFloat(e.target.value))
    );
  }

  goToMetadata() {
    this.props.onPrevious();
  }

  getTotalRowNumber(row) {
    let val = 0;

    if (this.props.data && this.props.data.data[0][row]) {
      val += parseInt(this.props.data.data[0][row])
    }

    if (this.props.data && this.props.data.data[1][row]) {
      val += parseInt(this.props.data.data[1][row])
    }

    return val;
  }

  getTotalNumber(index, prefix) {
    let val = 0;

    if (this.props.data && this.props.data.data[index][prefix+"_officials"]) {
      val += parseInt(this.props.data.data[index][prefix+"_officials"])
    }

    if (this.props.data && this.props.data.data[index][prefix+"_executives"]) {
      val += parseInt(this.props.data.data[index][prefix+"_executives"])
    }

    if (this.props.data && this.props.data.data[index][prefix+"_professionals"]) {
      val += parseInt(this.props.data.data[index][prefix+"_professionals"])
    }

    if (this.props.data && this.props.data.data[index][prefix+"_associate"]) {
      val += parseInt(this.props.data.data[index][prefix+"_associate"])
    }

    if (this.props.data && this.props.data.data[index][prefix+"_general"]) {
      val += parseInt(this.props.data.data[index][prefix+"_general"])
    }

    return val;
  }

  getProportionsColumns(index, column1, column2) {

    if (this.props.data && this.props.data.data[index][column1] !== null && this.props.data.data[2][column2] && (this.props.data.data[2][column2]  !== 0)) {
      return ((parseInt(this.props.data.data[index][column1])/parseInt(this.props.data.data[2][column2]))*100.00).toFixed(2);
    }
    else return 0;
  }

  getProportionsTotalsRow(column1, column2) {

    if (this.props.data && this.props.data.data[2][column1] && parseInt(this.props.data.data[2][column1]) !== 0) {
      return ((parseInt(this.props.data.data[2][column1])/parseInt(this.props.data.data[2][column2]))*100.00).toFixed(2);
    }
    else return 0;
  }
  
  getProportionsRowTotals(column1) {

    if (this.props.data && this.props.data.data[2][column1] && parseInt(this.props.data.data[2][column1]) !== 0) {
      // console.log(column1, ((parseInt(this.props.data.data[2][column1])/(parseInt(this.getTotalNumber(2,"total"))))*100.00).toFixed(2))
      return ((parseInt(this.props.data.data[2][column1])/(parseInt(this.props.data.data[2]["total_national"])))*100.00).toFixed(2);
    }
    else return 0;
  }

  getProportionsColumnTotals(index, column1) {

    if (this.props.data && parseInt(this.getTotalNumber(index, column1)) !== 0) {
      return ((parseInt(this.getTotalNumber(index, column1))/(parseInt(this.props.data.data[2]["total_national"])))*100.00).toFixed(2);
    }
    else return 0;
  }

  updateRatioField(column, name) {
    // Calculate the proportion value
    const proportionStr = this.getProportionsColumns(1, column, column);
    const proportionVal = parseFloat(proportionStr) || 0;
    const calculatedValue = (proportionVal / 50).toFixed(2);

    // Auto-update if the stored value is null or different from calculated value
    if (this.props.data && this.props.data.ratios && this.props.data.ratios[0] && !isNaN(proportionVal)) {
      const storedValue = this.props.data.ratios[0][name];
      if (storedValue === null || storedValue === undefined || 
          parseFloat(storedValue).toFixed(2) !== calculatedValue) {
        let { dispatch } = this.props;
        dispatch(
          sdg1671bActions.updateRatios(name, parseFloat(calculatedValue))
        );
      }
    }
    return calculatedValue;
  }

  canCalculateRatio(column) {
    // Check if the ratio can be calculated from proportions data
    if (!this.props.data || !this.props.data.data) {
      return false;
    }
    
    // Check if the required data exists for calculation
    // Calculation requires: data[1][column] and data[2][column] where data[2][column] != 0
    const hasDataRow1 = this.props.data.data[1] && 
                       this.props.data.data[1][column] !== null && 
                       this.props.data.data[1][column] !== undefined;
    
    const hasDataRow2 = this.props.data.data[2] && 
                       this.props.data.data[2][column] !== null && 
                       this.props.data.data[2][column] !== undefined &&
                       parseInt(this.props.data.data[2][column]) !== 0;
    
    return hasDataRow1 && hasDataRow2;
  }

  getRatioValue(column, name) {
    // For OGC users, return the stored value if it exists, otherwise calculate it
    // For non-OGC users, always calculate it
    const isOGC = this.props.user && this.props.user.user_type === "OGC";
    
    // Check if value can be calculated
    const canCalculate = this.canCalculateRatio(column);
    
    // If value can be calculated, always use calculated value (calculation takes priority)
    if (canCalculate) {
      return this.updateRatioField(column, name);
    }
    
    // If user is currently editing this field, return the local value
    if (isOGC && this.state.editingFields && this.state.editingFields[name] !== undefined) {
      return this.state.editingFields[name];
    }
    
    // If calculation is not possible, return stored value (for both OGC and non-OGC users)
    if (this.props.data && this.props.data.ratios && this.props.data.ratios[0]) {
      const storedValue = this.props.data.ratios[0][name];
      
      // If value is null, undefined, or 0, show "0.00" by default
      if (storedValue === null || storedValue === undefined || storedValue === 0) {
        return "0.00";
      }
      
      // Return formatted stored value
      return parseFloat(storedValue).toFixed(2);
    }
    
    // If no data exists at all, return "0.00"
    return "0.00";
  }

  calculateYouthRatio() {
    const val = ((parseFloat(this.getProportionsRowTotals("below_25")) + parseFloat(this.getProportionsRowTotals("age_25_34")))/this.props.data.denominator["youth_ratio"]).toFixed(2)

    // Auto-update if the stored value is null or different from calculated value
    if (this.props.data && this.props.data.ratios && this.props.data.ratios[0] && !isNaN(val)) {
      const storedValue = this.props.data.ratios[0]["bellow34_total_national"];
      if (storedValue === null || storedValue === undefined || parseFloat(storedValue).toFixed(2) !== val) {
        let { dispatch } = this.props;
        dispatch(
          sdg1671bActions.updateRatios("bellow34_total_national", parseFloat(val))
        );
      }
    }

    return val;
  }

  calculateRatioWithDenominator(proportion, denominator, name) {
    const val = (this.getProportionsRowTotals(proportion)/this.props.data.denominator[denominator]).toFixed(2)

    // Auto-update if the stored value is null or different from calculated value
    if (this.props.data && this.props.data.ratios && this.props.data.ratios[0] && !isNaN(val)) {
      const storedValue = this.props.data.ratios[0][name];
      if (storedValue === null || storedValue === undefined || parseFloat(storedValue).toFixed(2) !== val) {
        let { dispatch } = this.props;
        dispatch(
          sdg1671bActions.updateRatios(name, parseFloat(val))
        );
      }
    }

    return val;
  }



  render() {
    //console.log("Render");
    return (
      <React.Fragment>
        <div className="box-body">
          <div className="col-sm-8">
            <h3>TABLE 3: Ratios</h3>
          </div>
          <div className="row">
            <div className="col-sm-12 adaptive-table">
              <fieldset
                disabled={this.props.data && (!this.props.data.id || this.props.data.id === null)}
              >
                <table className="table table-bordered table-1671b">
                  <thead>
                    <tr>
                      <th width="25%"></th>
                      <th style={{background:"#A9D08E"}} colSpan="2">
                        Female representation ratios
                      </th>
                      <th style={{background:"#A9D08E"}} colSpan="2">
                        ‘Youth’ representation ratios
                      </th>
                      <th style={{background:"#A9D08E"}} colSpan="2">
                        Disabled persons representation ratios
                      </th>
                      <th style={{background:"#A9D08E"}} colSpan="2">
                        Population group A representation ratios
                      </th>
                      <th style={{background:"#A9D08E"}} colSpan="2">
                        Population group B representation ratios
                      </th>
                      <th style={{background:"#A9D08E"}} colSpan="2">
                        Population group C representation ratios
                      </th>
                    </tr>
                    <tr>
                      <th width="30%"></th>
                      <th colSpan="2">
                        Proportion of female public servants in [occupational category x] / Proportion of women in the working-age population
                      </th>
                      <th colSpan="2">
                        Proportion of ‘young’ public servants aged 34 and below in [occupational category x] / Proportion of the working-age population aged above the eligibility age for a public service job and below 35
                      </th>
                      <th colSpan="2">
                        Proportion of disabled public servants in [occupational category x] / Proportion of disabled persons in the working-age population
                      </th>
                      <th colSpan="2">
                        Proportion of public servants belonging to population group A in [occupational category x] / Proportion of population group A in the working-age population
                      </th>
                      <th colSpan="2">
                        Proportion of public servants belonging to population group B in [occupational category x] / Proportion of population group B in the working-age population
                      </th>
                      <th colSpan="2">
                        Proportion of public servants belonging to population group C in [occupational category x] / Proportion of population group C in the working-age population
                      </th>
                    </tr>
                    <tr>
                      <th width="30%"></th>
                      <th>
                        Denominator:
                      </th>
                      <th>
                        50%
                      </th>
                      <th>
                        Denominator:
                      </th>
                      <th>
                        Already provided to us by UNDESA for each country (Proportion of the population (both sexes) aged above 18 (the 'default' eligibility age for a public service job) and below 35)
                        <NumberInput
                          id="youth_ratio"
                          name="youth_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data.denominator && this.props.data.denominator["youth_ratio"] != null
                              ? this.props.data.denominator["youth_ratio"]
                              : 0
                          }
                        />
                      </th>
                      <th>
                        Denominator:
                      </th>
                      <th>
                        Needs to be determined by each country (Proportion of disabled persons in the working-age population, for both sexes, above eligibility age and below retirement age for a public service job)
                        <NumberInput
                          id="disabled_ratio"
                          name="disabled_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data.denominator && this.props.data.denominator["disabled_ratio"]
                              ? this.props.data.denominator["disabled_ratio"]
                              : 0
                          }
                        />

                      </th>
                      <th>
                        Denominator:
                      </th>
                      <th>
                        Needs to be determined by each country (Proportion of population group A in the working-age population, for both sexes, above eligibility age and below retirement age for a public service job)
                        <NumberInput
                          id="group_a_ratio"
                          name="group_a_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data.denominator && this.props.data.denominator["group_a_ratio"]
                              ? this.props.data.denominator["group_a_ratio"]
                              : 0
                          }
                        />
                      </th>
                      <th>
                        Denominator:
                      </th>
                      <th>
                        Needs to be determined by each country (Proportion of population group B in the working-age population, for both sexes, above eligibility age and below retirement age for a public service job)
                        <NumberInput
                          id="group_b_ratio"
                          name="group_b_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data.denominator && this.props.data.denominator["group_b_ratio"]
                              ? this.props.data.denominator["group_b_ratio"]
                              : 0
                          }
                        />
                      </th>
                      <th>
                        Denominator:
                      </th>
                      <th>
                        Needs to be determined by each country (Proportion of population group C in the working-age population, for both sexes, above eligibility age and below retirement age for a public service job)
                        <NumberInput
                          id="group_c_ratio"
                          name="group_c_ratio"
                          // className="input-1671b"
                          label=""
                          onChange={this.updateDenominator}
                          value={
                            this.props.data && this.props.data.denominator && this.props.data.denominator["group_c_ratio"]
                              ? this.props.data.denominator["group_c_ratio"]
                              : 0
                          }
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{background:"#A9D08E"}} colSpan="13">
                        Total public service personnel
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Senior Managers: Senior Government Officials
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="female_senior_managers"
                          name="female_senior_managers"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioValue("total_officials", "female_senior_managers")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatio("total_officials")
                          }
                        />

                      </td>
                    </tr>
                    <tr>
                      <td>
                        Other Managers: Managing Directors and Chief Executives and Business Services and Administration Managers
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="female_other_managers"
                          name="female_other_managers"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioValue("total_executives", "female_other_managers")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatio("total_executives")
                          }
                        />

                      </td>
                    </tr>
                    <tr>
                      <td>
                        Administration Professionals
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="female_administration_professionals"
                          name="female_administration_professionals"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioValue("total_professionals", "female_administration_professionals")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatio("total_professionals")
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Business and Administration Associate Professionals
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="female_ba_associate_professionals"
                          name="female_ba_associate_professionals"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioValue("total_associate", "female_ba_associate_professionals")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatio("total_associate")
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        General and Keyboard Clerks
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="female_gk_clerks"
                          name="female_gk_clerks"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioValue("total_general", "female_gk_clerks")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatio("total_general")
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total national-level public service personnel (including police, education, health, front-desk administrative and all other public service personnel)
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="female_total_national"
                          name="female_total_national"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioValue("total_national", "female_total_national")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatio("total_national")
                          }
                        />
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="bellow34_total_national"
                          name="bellow34_total_national"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getYouthRatioValue()}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateYouthRatio()
                          }
                        />
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="disabled_total_national"
                          name="disabled_total_national"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioWithDenominatorValue("disability", "disabled_ratio", "disabled_total_national")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatioWithDenominator("disability", "disabled_ratio")
                          }
                        />
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="population_a_total_national"
                          name="population_a_total_national"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioWithDenominatorValue("group_a_value", "group_a_ratio", "population_a_total_national")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatioWithDenominator("group_a_value", "group_a_ratio")
                          }
                        />
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="population_b_total_national"
                          name="population_b_total_national"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioWithDenominatorValue("group_b_value", "group_b_ratio", "population_b_total_national")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatioWithDenominator("group_b_value", "group_b_ratio")
                          }
                        />
                      </td>
                      <td colSpan="2">
                        <TextInput
                          id="population_c_national"
                          name="population_c_national"
                          // className="input-1671b"
                          labelText=""
                          onChange={this.handleChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          value={this.getRatioWithDenominatorValue("group_c_value", "group_c_ratio", "population_c_national")}
                          disabled={
                            !(this.props.user && this.props.user.user_type === "OGC") ||
                            this.canCalculateRatioWithDenominator("group_c_value", "group_c_ratio")
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { data } = state.sdg1671bState;
  const { user } = state.authentication;

  return {
    data,
    user
  };
}

const connectedIndicatorData = connect(mapStateToProps)(RatiosTable);

export { connectedIndicatorData as RatiosTable };
